import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'
import Con from '../../static/config.json'

Vue.use(Vueaxios, axios)
const URL = Con.URL
export default {
  getZone (obj, header, success, error) {
    Vue.axios.post(URL + 'homezone/search', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  searchInvoice (obj, header, success, error) {
    Vue.axios.post(URL + 'invoice/search', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  cancelInvoice (obj, header, success, error) {
    Vue.axios.post(URL + 'invoice/cancel', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  searchDetail (id, header, success, error) {
    Vue.axios.get(URL + 'invoice/' + id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getPublicInvoice (key, header, success, error) {
    Vue.axios.get(URL + 'invoice/public/' + key, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service_invoice.js